import {Utilities} from '@shared/utilities/utilities.model';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';

export class CheckPreEvaluationModel {
	public static DOUBLE_KEYS = 'DOUBLE_KEYS';
	public static INSURANCE_CERTIFICATE = 'INSURANCE_CERTIFICATE';
	public static REGISTRATION = 'REGISTRATION';
	public static FRONT_PLATE = 'FRONT_PLATE';
	public static REAR_PLATE = 'REAR_PLATE';
	public static STICKERS = 'STICKERS';
    public static FAM_1 = 'fam1';
    public static FAM_2 = 'fam2';
    public static FAM_3 = 'fam3';

	public static readonly CPreEvaluation = [{id: CheckPreEvaluationModel.DOUBLE_KEYS, descr: 'Doppie chiavi' },
											 {id: CheckPreEvaluationModel.INSURANCE_CERTIFICATE, descr: 'Certificato assicurativo'},
											 {id: CheckPreEvaluationModel.REGISTRATION, descr: 'Libretto' },
											 {id: CheckPreEvaluationModel.FRONT_PLATE, descr: 'Targa anteriore' },
                                             {id: CheckPreEvaluationModel.REAR_PLATE, descr: 'Targa posteriore' },
                                             {id: CheckPreEvaluationModel.FAM_1, descr: 'Doppie chiavi'},
                                             {id: CheckPreEvaluationModel.FAM_2, descr: 'Tagliando'},
                                             {id: CheckPreEvaluationModel.FAM_3, descr: 'Dotazioni di circolazione'}];

	check_id?: string;
	check: boolean;
	status?: string;
	note?: string;
	reentered?: string;
	value?: boolean;

	private updatedStatus: Subject<boolean> = new Subject();
	public update_status: Observable<boolean> = this.updatedStatus.asObservable();

	isReady = false;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.check_id = model.check_id;
			this.check = model.check;
			this.status = model.status;
			this.reentered = model.reentered;
			this.note = model.note;
			this.value = model.value;
			this.setReady()
		}
	}

	setting(check: CheckPreEvaluationModel) {
		if (!Utilities.isVoid(check)) {
			this.check = check.check;
			this.status = check.status; 
			this.value = check.value; 
			this.notifyUpdate();
		}
	}

	getBody(): any {
		return {
			check_id: this.check_id,
			check: this.check,
			status: this.status,
			note: this.note,
			reentered: this.reentered,
			value: this.value
		}
	}

	setReady() {
		this.isReady = this.check || !Utilities.isVoid(this.status);
	}

	notifyUpdate() {
		this.setReady();
		this.updatedStatus.next(true);
	}
}
